import { AdministrationTab } from "@/app/types/admin/AdministrationTab";
import { URLs } from "@/app/utils/URLs";
import { LOCALES } from "@/app/vars/Languages";
import { UrlParam } from "@/app/vars/Urls";

export const APP_URL = URLs.getServerUrl() || "";

let APP_URL_PREFIX = APP_URL;

if (!APP_URL_PREFIX.endsWith("/")) {
  APP_URL_PREFIX += "/";
}

let locale = LOCALES[0];

if (typeof window !== "undefined") {
  for (const _locale of LOCALES) {
    locale = "";
    const pathname = window.location.pathname || "";
    if (pathname.startsWith(`/${_locale}/`) || pathname === `/${_locale}`) {
      locale = _locale;
      break;
    }
  }
}

APP_URL_PREFIX += locale;

export const PublicPaths = {
  HOME: "/",
  BLOG: "/blog",
} as const;

export const LegalPaths = {
  PRIVACY: "/privacy",
  TERMS: "/terms",
} as const;

export const BlogSlugs = {
  CALL_ANALYSIS_TOOLS: {
    fr: "analyser-appels-vente-outils",
    en: "analysing-sales-calls-tools",
  },
  DEMO_CALL: {
    fr: "analyser-appel-demo",
    en: "analysing-demo-calls",
  },
  REALTIME_ANALYSIS: {
    fr: "analyse-appels-temps-reel-ou-apres",
    en: "real-time-vs-post-call-analysis",
  },
  MODJO_ALTERNATIVES: {
    fr: "alternative-a-modjo",
    en: "modjo-alternatives",
  },
  LEEXI_PRICING: {
    fr: "leexi-prix-fonctionnalites-limites",
    en: "leexi-pricing-features-limits",
  },
  FREE_CALL_ANALYSIS: {
    fr: "outil-analyse-appels-vente-gratuit",
    en: "free-sales-call-analysis-tool",
  },
  CALL_RECORDING_GDPR: {
    fr: "enregistrer-appels-clients-rgpd",
    en: "record-customer-calls-gdpr",
  },
  SMALL_TEAM_CALL_ANALYSIS: {
    fr: "analyser-ses-appels-seul-petite-equipe",
    en: "analyse-calls-solo-small-team",
  },
  DISCOVERY_CALL: {
    fr: "appel-de-decouverte-questions",
    en: "discovery-call-questions",
  },
  WIN_LOSS_ANALYSIS: {
    fr: "analyse-win-loss-appels-vente",
    en: "win-loss-analysis-sales-calls",
  },
  SALES_KNOWLEDGE_BASE: {
    fr: "garder-connaissance-client-depart-commercial",
    en: "keep-customer-knowledge-when-reps-leave",
  },
  OBJECTION_HANDLING: {
    fr: "traiter-objections-ce-que-disent-clients",
    en: "handle-objections-from-real-calls",
  },
  SALES_CS_HANDOVER: {
    fr: "passation-sales-customer-success",
    en: "sales-to-customer-success-handover",
  },
  MCP_SALES_CALLS: {
    fr: "connecter-claude-chatgpt-appels-vente-mcp",
    en: "connect-claude-chatgpt-sales-calls-mcp",
  },
} as const;

export const HelpPaths = {
  MCP: "/mcp",
  EXTENSION: "/extension",
} as const;

export const BrandPaths = {
  CHARTER: "/brand",
} as const;

export const ProtectedPaths = {
  CALL_ANALYSIS: "/call-analysis",
  CLIENT_AVATAR: "/client-avatar",
  PROSPECT_SEARCH: "/prospect-search",
  MESSAGES_CONTENT: "/messages-content",
  ADMINISTRATION: "/administration",
  PROJECT: "/projects",
  OFFER: "/offers",
} as const;

export const SitemapRoutes = { ...PublicPaths, ...HelpPaths };

export const Routes = {
  HOME: APP_URL_PREFIX,
  BLOG: `${APP_URL_PREFIX}${PublicPaths.BLOG}`,
  PRIVACY: `${APP_URL_PREFIX}${LegalPaths.PRIVACY}`,
  TERMS: `${APP_URL_PREFIX}${LegalPaths.TERMS}`,
  MCP_GUIDE: `${APP_URL_PREFIX}${HelpPaths.MCP}`,
  EXTENSION_GUIDE: `${APP_URL_PREFIX}${HelpPaths.EXTENSION}`,
  PROTECTED: {
    CALL_ANALYSIS: `${APP_URL_PREFIX}${ProtectedPaths.CALL_ANALYSIS}`,
    CLIENT_AVATAR: `${APP_URL_PREFIX}${ProtectedPaths.CLIENT_AVATAR}`,
    PROSPECT_SEARCH: `${APP_URL_PREFIX}${ProtectedPaths.PROSPECT_SEARCH}`,
    MESSAGES_CONTENT: `${APP_URL_PREFIX}${ProtectedPaths.MESSAGES_CONTENT}`,
    ADMINISTRATION: `${APP_URL_PREFIX}${ProtectedPaths.ADMINISTRATION}`,
    ADMIN_USER: (uuid: string) =>
      `${APP_URL_PREFIX}${ProtectedPaths.ADMINISTRATION}?${UrlParam.TAB}=${AdministrationTab.USERS}&${UrlParam.USER}=${uuid}`,
    OFFER: (uuid: string) => `${APP_URL_PREFIX}${ProtectedPaths.OFFER}/${uuid}`,
    PROJECT: (uuid: string) => `${APP_URL_PREFIX}${ProtectedPaths.PROJECT}/${uuid}`,
  },
};
